const CV = () => {
    return (
        <div>
            <h1>CV</h1>
            <p>CV</p>
        </div>
    )
}

export default CV